export default {
  computed: {
    adminView() {
      // Permissions for if they can send payments
      let paymentAdminRoles = [
        "20PaymentsAdminV2",
        "20Payments+GeneralAdminV2",
        "30FinanceAdminV2",
        "40ClientAdminV2",
        // "98WhistleFinanceAdminV2"
      ];
      return (
        this.permissions.includes("wallets:create:cashpayment") ||
        this.roles.find((x) => paymentAdminRoles.includes(x))
      );
    },
  },
};
